import styled from 'styled-components';
import { Table } from '../../../styles/table.style';
import theme from 'src/theme';

export const EnginesSectionWrapper = styled.div``;

type Props = {
    gridCol?: number;
    gridColSpan?: number;
    isHalfWidth?: boolean;
    gridCols?: number;
    resetCols?: boolean;
};

export const EngineWrapper = styled.div<Props>`
    ${(props) => {
        if (props.gridCol && props.gridColSpan) {
            return `grid-column: ${props.gridCol} / span ${props.gridColSpan};`;
        }
        if (props.gridCol) {
            return `grid-column: ${props.gridCol};`;
        }
        return '';
    }}
`;

export const AolInputTable = styled(Table)`
    tr {
        margin: 5px 0;
    }
    th:first-child,
    td:first-child {
        width: 70%;
        padding: 0;
        font-size: unset;
        font-weight: unset;
    }

    th:first-child {
        padding: 0;
    }
`;

export const ListInputWrapper = styled.div`
    margin: 0.25rem 0;
`;

export const ListInputRow = styled.div`
    display: grid;
    grid-template-columns: 70% 1fr;
    height: 2rem;
`;

export const ListInputDescription = styled.div`
    width: 70%;
`;

export const ListInputValue = styled.div`
    display: grid;
    grid-template-columns: 50% 1fr;

    div {
        width: 5rem;
        text-align: center;
    }
`;
export const ErrorMessageWrapper = styled.div`
    color: ${theme.legacyColors.errorText};
`;

export const EngineListWrapper = styled.div<Props>`
    display: inline-block;
    width: ${(props) => (props.isHalfWidth ? '50%' : '100%')};
    margin: 0.25rem 0;
`;

export const EngineListHeader = styled.div`
    font-weight: 500;
    text-align: center;
`;

export const EngineListDescriptionsWrapper = styled.div`
    div {
        height: 32px;
        margin: 5px 0;
        line-height: 0;
    }
`;

export const EngineListRow = styled.div<Props>`
    display: grid;
    grid-template-columns: ${(props) => (props.resetCols ? '1fr' : 'minmax(min-content, 1fr) 1fr')};
    align-items: center;

    .input-value-wrapper,
    .input-value {
        margin: 0 !important;
        float: unset !important;
    }

    .read-only-input,
    .input-unit {
        // width: unset !important;
    }

    .first-header-col {
        justify-self: left;
    }
`;

export const EngineListValue = styled.span`
    .input-value-wrapper,
    .input-value {
        margin: 0 !important;
        float: unset !important;
    }

    .read-only-input,
    .input-unit {
        width: unset !important;
    }
`;

const getGridTemplateColumns = (gridCols: number) => {
    let cols = '';
    for (let i = 0; i < gridCols; i++) {
        cols += `1fr `;
    }

    return cols;
};
export const EngineListValuesWrapper = styled.div<Props>`
    display: grid;
    grid-template-columns: ${(props) => (props.gridCols ? `${getGridTemplateColumns(props.gridCols)}` : '50% 1fr')};
    grid-column-gap: 0.25rem;
    justify-content: center;
`;

export const EngineListValues = styled.div`
    display: inline-block;
    padding: 0 0.5rem;

    .input-value-wrapper,
    .input-value {
        margin: 0 !important;
        float: unset !important;
    }

    .read-only-input,
    .input-unit {
        width: unset !important;
    }
`;

export const ColumnsWrapper = styled.div`
    grid-template-columns: 50% 50%;
    display: grid;
    width: 100%;
    grid-gap: 5px;
    padding-right: 10px;
    overflow-x: hidden;
    font-size: 0.8rem;

    select {
        width: 85px;
    }
`;
export const Column = styled.div`
    overflow-x: hidden;
    border-right: 1px solid #ddd;
    padding: 0 10px;
`;

type ConsumptionByUsageWrapperProps = {
    gridCols?: number;
};

export const ConsumptionByUsageWrapper = styled.div<ConsumptionByUsageWrapperProps>`
    display: grid;
    grid-template-columns: ${(props) => (props.gridCols ? `${getGridTemplateColumns(props.gridCols)}` : '50% 1fr 1fr')};
    label .input-value-wrapper {
        justify-content: center; !important;
    }
`;
